import React from "react";
import { Button, Divider } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { hasPermission } from "../../utils/helpers";

import styles from "./styles.module.css";

const AddNewFooter = ({ label, to, onClick, permission }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (permission && !hasPermission(permission)) return null;

  const handle = () => {
    if (onClick) {
      onClick();
      return;
    }

    const back = `${location.pathname}${location.search}`;
    navigate(`${to}${to.includes("?") ? "&" : "?"}return=${encodeURIComponent(back)}`);
  };

  return (
    <>
      <Divider className={styles.divider} />
      <div className={styles.footer}>
        <Button
          type="link"
          block
          size="small"
          icon={<PlusOutlined />}
          className={styles.button}
          onMouseDown={(e) => e.preventDefault()}
          onClick={handle}
        >
          {label}
        </Button>
      </div>
    </>
  );
};

export const withAddNew = (menu, props) => (
  <>
    {menu}
    <AddNewFooter {...props} />
  </>
);

export default AddNewFooter;
